export const englishTranslations = {
  enterPatientID: "Enter patient ID:",
  info: "Info",
  info1: "Hello my dear friend.",
  info2: "Welcome to the wonderful app that is this beauty. It was developed by the fantastic guys over at Fishy Funksticks. Here's the low down:",
  info3: "You can slap a button on your home screen to add your request to the system. We then decide how important it is, and eventually give it to one of our lovely nurses who will come and give you all the help you need. You can add info about yourself in the options menu, as well as change how the site looks, feels and smells.",
  info4:  "But ya, that's about it. Peace out.",

  LanguagePref:  "Preferred language...",

  logout:  "logout",

  nurse:  "NURSE",
  patient:  "PATIENT",
  iama: "I am a...",
  submit: "SUBMIT",


  username:  "Enter username:",
  password:  "Enter password:",
  invalidcred: "Invalid credentials, try again!",
  invalidval: "Please input valid values.",

  patientid:  "Patient ID", 
  requesttype:  "Type of request", 
  extrainfo: "Extra info",
  done:  "Mark as done",

  yournexttask:  "Your next task",
  break:  "Break",
  schedulebreak:  "Schedule break",

  timeblockedout:  "What time do you want to block out?",
  leave:  "Leave:",
  return:  "Return:",

  neurodiverse:  "Neurodiverse",
  nonverbal:  "Nonverbal",
  ESL:  "Enlish as a second language",
  other:  "Other",
  dark:  "DARK",
  light:  "LIGHT",
  options:  "Options",
  Iam:  "I am...",

  food:  "Get food",
  water:  "Get water",
  toilet :  "Go toilet",
  meds:  "Get medication",
  assist:  "Physical assistance",
  emergency:  "Emergency Emergency",
  settings:  "Settings",
  infoicon:  "Info",

  extrainfo:  "Would you like to add any extra information?",
  sendrequest:  "Send Request",
  adddeets:  "Add more detail here",
};
